import { Injectable, PLATFORM_ID, REQUEST, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { PwaService } from './pwa.service';

@Injectable({ providedIn: 'root' })
export class PreviewService {
  public previewToken: string = null;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly ssrRequest = inject(REQUEST, { optional: true });
  private readonly pwaService = inject(PwaService);

  constructor() {
    if (isPlatformServer(this.platformId) && this.ssrRequest) {
      this.checkPreviewToken(new URL(this.ssrRequest.url));
    } else if (this.pwaService.isPwa()) {
      this.checkPreviewToken(new URL(window.location.href));
    }
  }

  public checkPreviewToken(url: URL) {
    const queryParams = new URLSearchParams(url.search);
    if (queryParams.has('preview_token')) {
      this.previewToken = queryParams.get('preview_token');
    }
  }
}
